// Свайп влево-вправо листает посты. Вертикальный жест оставлен прокрутке и Telegram.

export interface Point {
  x: number
  y: number
}

export const SWIPE_MIN_PX = 60

/** 'next' — палец ушёл влево, 'prev' — вправо, null — это не листание. */
export function swipeDirection(start: Point, end: Point): 'next' | 'prev' | null {
  const dx = end.x - start.x
  const dy = end.y - start.y
  if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy) * 1.5) return null
  return dx < 0 ? 'next' : 'prev'
}

/** Полоса снизу у плеера, где родные кнопки и ползунок перемотки: там свайп не листает. */
export const PLAYER_CONTROLS_PX = 64

/** Касание по видео листает, если начато выше полосы управления плеером. */
export function swipeAllowedOnVideo(touchY: number, videoBottom: number): boolean {
  return touchY < videoBottom - PLAYER_CONTROLS_PX
}
